module.exports = __webpack_public_path__ + "img/iconYeWuHuoChePaiDui.fc01da9a.svg";